export default __webpack_public_path__ + "static/media/Carrie 9781408304792.0557f614.jpg";